exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".subscribe{text-align:center;padding:10px 0}.subscribe .error{color:red}.subscribe .waiting .spinnerWrapper{left:50%;width:40px;height:40px;overflow:hidden;position:relative;margin-left:-20px}.subscribe .waiting .spinnerWrapper .blackSpinner>div{background-color:#000!important}.subscribe .optIns{max-width:400px;margin-left:auto;margin-right:auto;text-align:left}.subscribe .optIns .btn-container{margin:10px 0;text-align:center}.subscribe .optIns .btn-container .saved{font-size:20px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/subscribe.scss
// module id = 1320
// module chunks = 2